import './resourceSearchForm.scss'
import templateUrl from './resourceSearchForm.html'

/**
 * Resource Search Form component.
 *
 * Transcluded inside a {@link tmrResourceList Resource List} component.
 *
 * @example
 * <tmr-resource-search-form
 *   on-close=""
 *   on-submit=""
 *   on-clear=""
 *   is-disabled=""
 *   is-submit-disabled=""
 * ></tmr-resource-search-form>
 *
 * @type {ngComponent}
 * @prop {function} on-close
 * @prop {function} on-submit
 * @prop {function} on-clear
 * @prop {function} is-disabled
 */
export const tmrResourceSearchForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceSearchFormController',
  bindings: {
    onClose: '&',
    onSubmit: '&',
    onClear: '&',
    isDisabled: '&',
    isSubmitDisabled: '&',
    ngShow: '<',
  },
  transclude: {
    filters: 'tmrResourceFilters',
  },
}

export class tmrResourceSearchFormController {
  static ngType = 'controller'

  constructor($timeout) {
    'ngInject'
    this.$timeout = $timeout
  }

  $onChanges({ ngShow }) {
    // Focus automatico sul primo campo quando si apre la form
    if (
      (ngShow.previousValue === false || ngShow.isFirstChange()) &&
      ngShow.currentValue === true
    ) {
      // Dai tempo alla form di aprirsi
      this.$timeout(() => this.searchForm.$$controls?.[0].$$element?.focus())
    }
  }
}
